import InvestorCreateModal from "./InvestorCreateModal"

export default InvestorCreateModal
